import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Card, CardContent, Typography } from "@mui/material";
import { FC } from "react";
import { ISortableProps } from "../SortGame";

export const SortableItem: FC<ISortableProps> = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.id, disabled: props.disable });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Card
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      sx={{
        margin: "1em",
        cursor: props.disable ? "auto" : "move",
      }}
      elevation={props.disable ? 1 : 3}
    >
      <CardContent
        sx={{
          textAlign: "center",
          height: "45px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography>{props.children}</Typography>
      </CardContent>
    </Card>
  );
};
